var angular = require('angular')

angular.module('AemBranchesAppointments')
  .factory('appointmentsService', appointmentsService)

appointmentsService.$inject = ['$http', 'apiBase', '$location']

function appointmentsService ($http, apiBase, $location) {
  var endpointPath = apiBase + 'v1/appointments-external'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  function simulationHeader () {
    return ($location.search().simulation === 'true') ? { 'workingMode': 'SIMULATION' } : {}
  }

  function getFreeTimeSlots (dateFrom, dateTo, branchId, meetingLength, assistance, attendance) {
    return $http({
      url: endpoint('timeslots'),
      method: 'GET',
      cache: false,
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        branchId: branchId,
        meetingLength: meetingLength,
        assistanceType: assistance,
        attendanceType: attendance
      }
    })
  }

  function create (data) {
    return $http({
      url: endpoint('bookings'),
      headers: simulationHeader(),
      method: 'POST',
      data: data
    })
  }

  function get (id) {
    return $http({
      url: endpoint('bookings/' + id),
      method: 'GET',
      headers: simulationHeader(),
      cache: true
    })
  }

  function remove (id) {
    return $http({
      url: endpoint('bookings/' + id),
      headers: simulationHeader(),
      method: 'DELETE'
    })
  }

  return {
    getFreeTimeSlots: getFreeTimeSlots,
    create: create,
    get: get,
    remove: remove
  }
}
